export const _collectiblesList = [
  {
    id: '1',
    collection: 'bem-estar',
    name: 'bolsa térmica sustentável',
    image: '/assets/images/benefits/collectibles/bolsa-térmica.png',
    type: 'blocked',
  },
  {
    id: '2',
    collection: 'bem-estar',
    name: 'bolsa térmica sustentável',
    image: '/assets/images/benefits/collectibles/bolsa-térmica.png',
    type: 'blocked',
  },
  {
    id: '3',
    collection: 'bem-estar',
    name: 'bolsa térmica sustentável',
    image: '/assets/images/benefits/collectibles/bolsa-térmica.png',
    type: 'opened',
  },
  {
    id: '4',
    collection: 'bem-estar',
    name: 'bolsa térmica sustentável',
    image: '/assets/images/benefits/collectibles/bolsa-térmica.png',
    type: 'rescued',
  },
];

export const _collectionTimer = {
  collection: 'bem-estar',
  expireDate: new Date('2024-12-07T00:00:00Z'),
};

export const _collectibleDetails = {
  collectionImage: '/assets/images/benefits/collectibles/coleção-detalhe.png',
  collectionName: 'Bem-Estar',
  collectionItens: [
    {
      id: '1',
      name: 'Item 1',
      status: 'rescued',
    },
    {
      id: '2',
      name: 'Item 2',
      status: 'opened',
    },
    {
      id: '3',
      name: 'Item 3',
      status: 'closed',
    },
  ],
  productImage: '/assets/images/benefits/collectibles/produto-detalhe.png',
  productName: 'Bolsa térmica sustentável',
  productPoints: 50,
  rules: ['Regras da experiência', 'Regras da experiência', 'Regras da experiência'],
  untilDate: new Date(),
};

export const _levelPoints = [25, 50, 100, 500];
